//import sanityClient, { ClientConfig, SanityClient } from "@sanity/client";
import PicoSanityClient, { ClientConfig, PicoSanity } from "picosanity";
import React, { useContext } from "react";

export type SanityClientConfig = {
  projectId: string | undefined;
  dataset: string | undefined;
};

export const SanityClientConfigContext = React.createContext<
  ClientConfig | undefined
>(undefined);

export const useSanityClient = (
  extraOptions?: Partial<ClientConfig>
): PicoSanity | undefined => {
  const sanityClientConfig = useContext(SanityClientConfigContext);
  if (!sanityClientConfig) return undefined;
  const options = {
    ...sanityClientConfig,
    ...extraOptions
  } as ClientConfig;
  return new PicoSanityClient(options);
};
